import React, { useEffect, useState } from "react";
import { Container, Row, Modal, Button, Spinner } from "react-bootstrap";
import WorkshopList from "./WorkshopList";
import Cart from "./Cart";
import MembershipBox from "./MembershipBox";
import { connect } from "react-redux";
import {
  fetchCartAddons,
  setCartJobItems,
  setCartProducts,
  setCartStage,
  setCartWorkshop,
} from "../../../redux/actions/cartAction";
import CartBottomArea from "./CartBottomArea";
import {
  getWorkshopFilterMap,
  getWorkshopFilterMapMultiple,
  getWorkshopsAddonByVariant,
  getWorkshopsJourneyVariant,
  getWorkshopsProductCategory,
} from "../../../redux/actions/apiActions";
import { toast } from "react-hot-toast";
import { useRouter } from "next/router";
import { isMobile } from "react-device-detect";
import { gtmChooseWorkShop } from "../../../lib/google-tag-manager";
import { FaThumbsUp } from "react-icons/fa";
import API from "api";

const CartBody = ({
  id,
  getService,
  getAddon,
  serviceData,
  show,
  setShow,
  apiData,
  getWorkshopFilterMap,
  globalData,
  cart,
  setCartStage,
  setCartProducts,
  setCartWorkshop,
  setCartJobItems,
  getWorkshopsAddonByVariant,
  getWorkshopsJourneyVariant,
  getWorkshopsProductCategory,
}) => {
  const [levelUp, setLevelUp] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const router = useRouter();

  const { products } = cart;

  useEffect(() => {
    getService(serviceData);
    getAddon([]);
  }, [show, serviceData]);

  useEffect(() => {

    if (cart?.products && cart.products.length) {
      getWorkshopFilterMap(
        40,
        1,
        globalData.locationData?.lat,
        globalData.locationData?.lng,
        cart.products[0].Id,
        globalData.carData?.modelId,
        "Distance"
      );
    }
  }, [globalData?.carData]);

  const handleConfirmChange = () => {

    setCartStage(2);
    setCartProducts([cart.products[0]]);
    setCartJobItems([cart.jobItems[0]]);
    getWorkshopFilterMap(
      40,
      1,
      globalData.locationData?.lat,
      globalData.locationData?.lng,
      cart.products[0].Id,
      globalData.carData?.modelId,
      "Distance"
    );
    setShowWarning(false);
  };

  const handleChangeWorkshop = () => {

    if (cart.products.length > 1) {
      setShowWarning(true);
      return;
    }
    setCartStage(1);
    getWorkshopFilterMap(
      40,
      1,
      globalData.locationData?.lat,
      globalData.locationData?.lng,
      cart.products[0]?.Id,
      globalData.carData?.modelId,
      "Distance"
    );
  };

  const workShopNavigate = (value) => {
    const carData = JSON.parse(
      localStorage.getItem("car_data") || JSON.stringify("")
    );
    let carSlug =
      carData && carData.slug
        ? carData.slug
        : `${carData.brand} ${carData.modal}`
          .trim()
          .split(" ")
          .join("-")
          .toLowerCase()
          .split(".")
          .join("");
    let immutableUrl = "/";
    if (router.query.slug) {
      router.query.slug.map((item, index) => {
        immutableUrl += index == 3 ? value.Slug : item;
        immutableUrl += "/";
        return item;
      });
      if (router.query.slug.length < 3) {
        immutableUrl += `${carSlug}/${value.Slug}`;
      }
      if (router.query.slug.length == 3) {
        immutableUrl += value.Slug;
      }
    }
    immutableUrl += `?id=1`;
    router.push("/services" + immutableUrl, undefined, { shallow: true });
  };

  useEffect(async () => {
    if (cart && cart.products && cart.products?.length) {
      const { lat, lng } =
        globalData?.locationData ||
        JSON.parse(
          sessionStorage.getItem("location_data") || JSON.stringify("")
        );
      const { EmirateAreaId: areaId } =
        globalData?.locationData?.data ||
        JSON.parse(
          sessionStorage.getItem("location_data") || JSON.stringify("")
        )?.data;
      const { carData } = globalData;
      let carModelId;
      if (carData && carData?.modelId) {
        carModelId = carData?.modelId;
      }
      const { Id: variantId } = cart?.products[0];
      const productBrandId = localStorage.getItem("brand-id") || 1;

      await API.get(
        `v2/api/workshops/ob-recommend?variantId=${variantId}&carModelId=${carModelId}&productBrandId=${productBrandId}&lat=${lat}&lng=${lng}&areaId=${areaId}`
      )

        .then((res) => {
          if (res && res.data && res.data?.Data) {
            setShowButton(true);
          } else {
            setShowButton(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setShowButton(false);
        });
    }
  }, [cart.products]);

  const selectDefaultWorkshop = async () => {
    setLoading(true);
    const { lat, lng } =
      globalData?.locationData ||
      JSON.parse(sessionStorage.getItem("location_data") || JSON.stringify(""));
    const { EmirateAreaId: areaId } =
      globalData?.locationData?.data ||
      JSON.parse(sessionStorage.getItem("location_data") || JSON.stringify(""))
        ?.data;
    const { modelId: carModelId } = globalData?.carData;
    let variantId = null;
    variantId = cart.products[0]?.Id ? cart.products[0]?.Id : null;
    const productBrandId = localStorage.getItem("brand-id") || 1;
    await API.get(
      `v2/api/workshops/ob-recommend?variantId=${variantId}&carModelId=${carModelId}&productBrandId=${productBrandId}&lat=${lat}&lng=${lng}&areaId=${areaId}`
    )
      .then(async (res) => {
        if (res && res.data && res.data?.Data) {
          localStorage.setItem("isSmartSelection", true);
          const item = { ...res.data?.Data, isSmartChioce: true };
          gtmChooseWorkShop(item.Name);
          let brandId = null;
          if (products.length == 0) {
            getWorkshopsJourneyVariant(item.Id, id, mId);
            setShow(false);
            setCartWorkshop(item);
            let vId = JSON.parse(localStorage.getItem("product-id"));
            brandId = JSON.parse(
              localStorage.getItem("brand-id") || JSON.stringify("{}")
            );
            let mId = globalData.carData?.modelId;
            getWorkshopsAddonByVariant(item.Id, vId);

            getWorkshopsProductCategory(item.Id, mId);
            setCartStage(2);
            setLoading(false);
            workShopNavigate(item);
            return;
          }
          let jobs = [];
          await Promise.all(
            products?.map(async (variant) => {
              try {
                const { data } = await API.get(
                  `v2/api/workshops/${item?.Id}/jobs?page=1&variantId=${variant.Id}&carModelId=${globalData.carData?.modelId}&sortingCol=Distance&workshopId=${item?.Id}&lat=1&lng=1&size=40&brandId=${brandId}`
                );
                setShow(false);
                setCartWorkshop(item);
                jobs.push(data?.Data[0]);
                let vId = JSON.parse(localStorage.getItem("product-id"));
                let mId = globalData.carData?.modelId;
                getWorkshopsAddonByVariant(item.Id, vId);
                getWorkshopsJourneyVariant(item.Id, id, mId);

                getWorkshopsProductCategory(item.Id, mId);
                setLoading(false);
                workShopNavigate(item);
              } catch (error) {
                console.log("Error", e);
                setLoading(false);
                alert("something went wrong");
              }
            })
          );
          setCartJobItems([...jobs]);
          setCartStage(2);
          setLoading(false);
          workShopNavigate(item);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.dismiss();
        toast.error("Something went wrong! Please retry.");
        console.error(err);
      });
  };

  let selectedWorkshop = cart.workshop;
  const IsOBWorkshop = localStorage.getItem("obWorkshop");
  return (
    <Container
      className={`px-0 cart-list-area ${cart.stage == 2 ? "cart-list-area-on-second-step" : ""
        }`}
      fluid
    >
      <Row className="h-100 w-100 mx-0 flex-column">
        {globalData.locationData == null ||
          globalData.carData == null ||
          cart.stage == null ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img src="/assets/images/cart.webp" alt="cart" width={"100%"} />
            <div style={{ marginTop: "10%" }}>
              Go ahead and book a service for your car.
            </div>
          </div>
        ) : cart.stage == 1 ? (
          <>
            <WorkshopList
              id={id}
              setShow={setShow}
              getWorkshopFilterMap={getWorkshopFilterMap}
              setCartStage={setCartStage}
              setCartWorkshop={setCartWorkshop}
              removePaddingWhenAutoButtonIsHidden={
                !Boolean(
                  cart &&
                  showButton &&
                  cart.workshop == null &&
                  apiData.workshopFilterMap != ""
                )
              }
            />
            {apiData.workshopFilterMap == '' ?
              null
              : cart &&
                cart.workshop == null
                ? showButton ? (
                  <div
                    style={
                      isMobile
                        ? { width: "85%", margin: "0 7%", overflow: "hidden", background: "linear-gradient(0deg, rgba(247,146,34,1) 0%, rgba(255,50,1,1) 100%)" }
                        : { overflow: "hidden", marginTop: "10px", background: "linear-gradient(0deg, rgba(247,146,34,1) 0%, rgba(255,50,1,1) 100%)" }
                    }
                    className={"workshop-bottom-button-custom btmskp"}
                    onClick={selectDefaultWorkshop}
                  >
                    <div className="buttonBox width-height-center">
                      <div
                        id="fifth"
                        style={
                          isMobile
                            ? { fontSize: "15px", color: "white" }
                            : { fontSize: "18px", color: "white" }
                        }
                        className="workshop-select width-height-center"
                      >
                        Skip & Select Automatically{" "}
                        {loading ? (
                          <Spinner
                            animation="grow"
                            role="status"
                            className="ml-2"
                            size="sm"
                          >
                            <span className="visually-hidden"></span>
                          </Spinner>
                        ) : null}
                      </div>
                    </div>

                  </div>
                ) : null : <div className={"cart-bottom-box"}>
                  <div className="cart-bottom-in">
                    <CartBottomArea />
                    {loading ? (
                      <Spinner
                        animation="grow"
                        role="status"
                        className="ml-2"
                        size="sm"
                      >
                        <span className="visually-hidden"></span>
                      </Spinner>
                    ) : null}
                  </div>
                </div>}
          </>
        ) : (
          <>
            <Cart id={id} />
            <div className="cart-bottom-box">
              <div className="cart-bottom-in">
                {cart.addedPackages.length > 0 && (
                  <div className="workshop-bar change-garage p-2 border-bottom">
                    <div className="d-flex w-100">
                      <div className="ml-2">
                        <div className="font-weight-normal">
                          <em
                            className="font-weight-normal"
                            style={{ fontSize: 14 }}
                          >
                            (Your Service Contract will be handled by Open Bonnet
                            Partner Workshop)
                          </em>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {cart.workshop && !IsOBWorkshop ? (
                  <div className="island-fx-bottom">
                    <div className="workshop-list-block-crt">
                      <div className="island-header-bar">
                        <h3>Selected Workshop</h3>
                        {cart.stage == 4 && !sessionStorage.getItem('isWorkshopCollection') ?
                          <span
                            onClick={() => {
                              handleChangeWorkshop();
                            }}
                          >
                            Change
                          </span> : null}
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className="leftwrksh">
                          <small>
                            <img src={selectedWorkshop?.LogoUrl} />
                          </small>
                          <div className="wps-wrk-area">
                            <h3>{selectedWorkshop?.Name}</h3>
                            {localStorage.getItem("isSmartSelection") ? (
                              <label>
                                {" "}
                                <i className="fa fa-check" /> Smart Selection
                                Applied
                              </label>
                            ) : null}
                          </div>
                        </div>
                        <div className="rightwrksh">
                          <label>
                            <i className="fa-solid fa-location-dot" />
                            {" "}{`${selectedWorkshop?.AreaName}, ${selectedWorkshop?.EmirateName}`}
                          </label>
                        </div>
                      </div>
                    </div>
                    {/* <CartBottomArea /> */}
                  </div>
                ) : null}

                {/* {cart.stage == 3 ||
              cart.stage == 1 ||
              localStorage.getItem("hide_level_up") ? null : (
                <MembershipBox levelUp={levelUp} setLevelUp={setLevelUp} />
              )}  */}
                <CartBottomArea />
                {/* {cart.workshop && !IsOBWorkshop ? (
                <div className="workshop-bar change-garage p-2 d-flex justify-content-center align-items-center flex-direction-column">
                  <div className="d-flex w-75">
                    <img
                      src={selectedWorkshop?.LogoUrl}
                      alt="selectedWorkshop"
                      width={50}
                      height={50}
                      style={{ borderRadius: "10px", objectFit: "contain" }}
                    />
                    <div className="ml-2 w-100">
                      <div
                        style={
                          isMobile || localStorage.getItem("isSmartSelection")
                            ? { width: "80%" }
                            : {}
                        }
                      >
                        {selectedWorkshop?.Name}
                      </div>
                      <div
                        style={{ fontSize: 12 }}
                      >{`${selectedWorkshop?.AreaName}, ${selectedWorkshop?.EmirateName}`}</div>
                    </div>

                  </div>
                  {localStorage.getItem("isSmartSelection") ? (
                    <div
                      className={
                        isMobile
                          ? "workshop-tag-choice-mobile"
                          : "workshop-tag-choice-smart-selection"
                      }
                    >
                      <FaThumbsUp className="mr-1" />{" "}
                      <span>Smart Selection Applied</span>
                    </div>
                  ) : null}

                  <div
                    style={
                      isMobile && localStorage.getItem("isSmartSelection")
                        ? { marginTop: "20px", fontSize: "14px" }
                        : {}
                    }
                    onClick={() => {
                      handleChangeWorkshop();
                    }}
                    className="w-25 d-flex justify-content-end align-items-center change-btn-ft-cart"
                    role="button"
                  >
                    <button>Change</button>
                  </div>
                </div>
              ) : null}
              {cart.stage == 3 ||
              cart.stage == 1 ||
              localStorage.getItem("hide_level_up") ? null : (
                <MembershipBox levelUp={levelUp} setLevelUp={setLevelUp} />
              )}
              <CartBottomArea /> */}
              </div>
            </div>
          </>
        )}
      </Row>
      <Modal show={showWarning} onHide={() => setShowWarning(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Change Workshop</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>Want to change the your workshop? </h5>
          <p>
            The second service selected at this workshop will be removed from
            cart. Please add again at your new workshop.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConfirmChange}>
            Yes
          </Button>
          <Button variant="secondary" onClick={() => setShowWarning(false)}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getWorkshopsAddonByVariant: (id, vId) => {
      dispatch(getWorkshopsAddonByVariant(id, vId));
    },
    getWorkshopsJourneyVariant: (id, cId, mId) => {
      dispatch(getWorkshopsJourneyVariant(id, cId, mId));
    },
    getWorkshopsProductCategory: (id, mId) => {
      dispatch(getWorkshopsProductCategory(id, mId));
    },
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    setCartProducts: (products) => {
      dispatch(setCartProducts(products));
    },
    setCartJobItems: (jobs) => {
      dispatch(setCartJobItems(jobs));
    },
    setCartWorkshop: (data) => {
      dispatch(setCartWorkshop(data));
    },
    fetchCartAddons: (workshopId, variantId, carModeId) => {
      dispatch(fetchCartAddons(workshopId, variantId, carModeId));
    },
    getWorkshopFilterMap: (size, page, lat, lang, vId, mId, filter) => {
      dispatch(getWorkshopFilterMap(size, page, lat, lang, vId, mId, filter));
    },
    getWorkshopFilterMapMultiple: (
      size,
      page,
      lat,
      lang,
      vIds,
      mId,
      filter
    ) => {
      dispatch(
        getWorkshopFilterMapMultiple(size, page, lat, lang, vIds, mId, filter)
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CartBody);
